import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";

Vue.use(Vuex);

export const store = new Vuex.Store({
  strict: true,
  plugins: [createPersistedState()],
  state: {
    token: null,
    client_status: false,
    employee: {},
    initialMenu: [],
    menu: [],
    main_menu: [],
    company_menu: [],
    sub_company_menu: [],
    booking_agent_menu: [
      { name: "home", link: "/c/s/b/home", modules: [] },
      { name: "vehicle layouts", link: "/c/s/b/vehicle-layouts", modules: [] },
      { name: "routes", link: "/c/s/b/routes", modules: [] },
    ],
    booking_client_menu: [
      { name: "home", link: "/c/s/c/home", modules: [] },
      { name: "vehicle layouts", link: "/c/s/c/vehicle-layouts", modules: [] },
      { name: "routes", link: "/c/s/c/routes", modules: [] },
    ],
    module: [],
    companies: [],
    sub_companies: [],
    infobarStatus: false,
    infobar: {
      type: "",
      text: "",
      multi_line: false,
    },
    loading: false,
    unauthorized: false,
    tempData: null,
    company: {},
    subcompany: {},
    booking_agent: {},
    booking_client: {},
    enableNavDrawer: false,
    fareMatrixItems: [],
  },
  getters,
  mutations,
  actions,
});
